export const AddressFieldMaxLength = {
  street: 30,
  houseNumber: 30,
  city: 30,
  country: 30,
  /** General Austrian PLZ length (up to 5 digits). Vienna-only forms (courts) restrict this to 4. */
  zipCode: 5,
} as const;
